<template>
    <div class="ribbon">
        <app-ribbon-button v-for="(item, index) in buttons" :key="index" :icon="!!item.icon ? item.icon : 'fa fa-plus'">
            {{ item.label }}
        </app-ribbon-button>
    </div>
</template>

<script>
import appRibbonButton from './RibbonButton.vue'
export default {
    components: {
        appRibbonButton,
    },
    data() {
        return {
            buttons: [
                { label: 'Llamadas de citofonía', icon: 'fa fa-phone' },
                { label: 'Button 2', icon: 'fa fa-plus' },
                { label: 'Button 3', icon: 'fa fa-plus' },
                // ... add more buttons as needed
            ],
        }
    },
}
</script>

<style scoped>
.ribbon {
    display: flex;
    flex-direction: row-reverse;
    justify-content: flex-start;
    align-items: center;
    /* max-height: 50px; */
    /* border: 1px solid gray; */
    border-radius: 8px;
    max-width: 97%;
    margin: auto;
}

.ribbon > :first-child {
    border-top-right-radius: 8px;
    border-bottom-right-radius: 8px;
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
}

.ribbon > :last-child {
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
    border-top-left-radius: 8px;
    border-bottom-left-radius: 8px;
}
</style>
